import { LOADED, STATUS_CREATED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
    CHANGE_SELECT_WAREHOUSE: "change_select_warehouse",
    ARTICLES_LOADED: "articles_loaded",
    CHANGE_SELECT_ITEM_LOTE: "change_select_item_lote",
    ITEM_LOTES_NOT_LOADED: "item_lote_not_loaded",
    LOAD_INVENTORY_LOTES_ITEM: "load_inventory_lotes_item",
    RELOAD_INVENTORY_LOTES_ITEM: "reload_inventory_lotes_item",
    LOAD_INVENTORY_LOTES_ITEM_MEASURE_NAME: "load_inventory_lotes_item_measure_name",
    CHANGE_SELECT_ARTICLE: "change_select_article",
    DETAIL_ARTICLES_LOADED: "detail_articles_loaded",
    RELOAD_INVENTORY_LOTES_ITEM_INITIAL_STATE: "reload_inventory_lotes_item_initial_state",
    LOAD_IF_HAS_LOTE_ARTICLE: "load_if_has_lote_aricle",
    CHANGE_INPUT_FILTER_ARTICLES: "change_input_filter_articles",
    CHANGE_INPUT_FILTER_DETAIL_ARTICLES: "change_input_filter_detail_articles",
    CHANGE_WAREHOUSE_INVENTORY_FILTERS: "change_warehouse_inventory_filters",

};


export const INITIAL_STATE = {
    selected_warehouses: [],
    articles: {
      elements: [],
      status: STATUS_NOT_LOADED,
      filter: {
        name: null,
        reference: null,
        equivalent_measure_id: null,
        limit: 15,
        page: 1,
      },
      rows: 0,
      has_lote: true
    },
    detail_articles: {
      elements: [],
      status: STATUS_NOT_LOADED,
      filter: {
        name: null,
        reference: null,
        equivalent_measure_id: null,
        limit: 15,
        page: 1,
      },
      rows: 0,
    },
    lotes_item_selected:{
      items:{},
      measure_name: "",
      status: STATUS_NOT_LOADED,
    },
    select_article: {
      item_id: null,
      warehouse_id: null,
    },
}; 


export const inventoryArticlesReducer = (state, action) => {
    const payload = action.payload;
    const {
      CHANGE_SELECT_WAREHOUSE,
      ARTICLES_LOADED,
      CHANGE_SELECT_ITEM_LOTE,
      LOAD_INVENTORY_LOTES_ITEM,
      RELOAD_INVENTORY_LOTES_ITEM,
      LOAD_INVENTORY_LOTES_ITEM_MEASURE_NAME,
      CHANGE_SELECT_ARTICLE,
      DETAIL_ARTICLES_LOADED,
      RELOAD_INVENTORY_LOTES_ITEM_INITIAL_STATE,
      LOAD_IF_HAS_LOTE_ARTICLE,
      CHANGE_INPUT_FILTER_ARTICLES,
      CHANGE_INPUT_FILTER_DETAIL_ARTICLES,
      CHANGE_WAREHOUSE_INVENTORY_FILTERS,
  
    } = types;
    switch (action.type) {
        case CHANGE_SELECT_WAREHOUSE: {
            const selected_warehouses = Array.isArray(action.payload) ? action.payload : [];
            const clearArticles = selected_warehouses.length === 0;
            return {
                ...state,
                selected_warehouses,
                ...(clearArticles && {
                    articles: { ...state.articles, elements: [], rows: 0 },
                    detail_articles: { ...state.detail_articles, elements: [], rows: 0 },
                }),
            };
        }

      case ARTICLES_LOADED:
      return {
        ...state,
        articles: {
          ...state.articles,
          elements: payload.elements,
          status: LOADED,
          rows: payload.rows,
        },
      };

      case DETAIL_ARTICLES_LOADED:
      return {
        ...state,
        detail_articles: {
          ...state.detail_articles,
          elements: payload.elements,
          status: LOADED,
          rows: payload.rows,
        },
      };

      case CHANGE_SELECT_ITEM_LOTE:
        return {
            ...state.lotes_item_selected,
            items: action.payload

        };
      


        case LOAD_INVENTORY_LOTES_ITEM:
          return { ...state, 
            lotes_item_selected:{
              ...state.lotes_item_selected,
              items: action.payload,
              status: LOADED,
            }
          };
    
        case RELOAD_INVENTORY_LOTES_ITEM:
          return {
                ...state,
                lotes_item_selected: {
                    ...state.lotes_item_selected,
                    status: STATUS_NOT_LOADED,
                  },
          };
        
          case LOAD_INVENTORY_LOTES_ITEM_MEASURE_NAME:
            return { ...state, 
              lotes_item_selected:{
                ...state.lotes_item_selected,
                measure_name: action.payload,
                status: LOADED,
              }
            };

        case CHANGE_SELECT_ARTICLE:
          return {
              ...state,
              select_article: action.payload
          };

          case RELOAD_INVENTORY_LOTES_ITEM_INITIAL_STATE:
          return {
                ...state,
                lotes_item_selected: INITIAL_STATE.lotes_item_selected
          };
        
          case LOAD_IF_HAS_LOTE_ARTICLE:
            return {
              ...state,
              articles: {
                ...state.articles,
                has_lote: action.payload
              },
            };

            case CHANGE_INPUT_FILTER_ARTICLES:
              return {
                  ...state,
                  articles: {
                    ...state.articles,
                    filter: {
                      ...state.articles.filter,
                      [payload.name]: payload.value,
                      },
                    status: STATUS_NOT_LOADED,
                      
                  }
                  
      
              };

              case CHANGE_INPUT_FILTER_DETAIL_ARTICLES:
              return {
                  ...state,
                  detail_articles: {
                    ...state.detail_articles,
                    filter: {
                      ...state.detail_articles.filter,
                      [payload.name]: payload.value,
                      },
                    status: STATUS_NOT_LOADED,
                      
                  }
                  
      
              };

              case CHANGE_WAREHOUSE_INVENTORY_FILTERS: {
                const patch = action.payload || {};
                return {
                  ...state,
                  articles: {
                    ...state.articles,
                    filter: {
                      ...state.articles.filter,
                      ...patch,
                      page: 1,
                    },
                    status: STATUS_NOT_LOADED,
                  },
                  detail_articles: {
                    ...state.detail_articles,
                    filter: {
                      ...state.detail_articles.filter,
                      ...patch,
                      page: 1,
                    },
                    status: STATUS_NOT_LOADED,
                  },
                };
              }

              

      default:
        return state;
    }
  };


